const BadSurvey = () => {
  return (
    <div>
      <h1>Encuesta no disponible</h1>
    </div>
  );
};

export default BadSurvey;
